import { initializeApp, getApp } from 'firebase/app'
import { getToken, onMessage, getMessaging, deleteToken } from 'firebase/messaging'

export const useFirebase = () => {
  const getFBToken = async () => {
    const app = initializeApp(firebaseConfig)
    const messaging = getMessaging(app)
    onMessage(messaging, (payload) => {
      if (payload.data?.context === 'chat-message') {
        logger.log('Received talkjs notification, skipping notification list item append...', payload)
        return
      }

      try {
        const objNotificationMsg = fbToNotification(JSON.parse(payload.data!.notification!), logger)
        const notifStore = useNotificationStore()
        const { userNotifications } = storeToRefs(notifStore)

        userNotifications.value.unshift(objNotificationMsg)
      }
      catch (e) {
        logger.error('Error parsing notification message', undefined, e as Error)
      }
    })

    let registration
    if ('serviceWorker' in navigator) {
      try {
        registration = await navigator.serviceWorker.register('./fb-sw.js', { scope: '/firebase-cloud-messaging-push-scope' })
        await navigator.serviceWorker.ready
      }
      catch (e) {
        logger.error('Error registering firebase service worker', undefined, e as Error)
      }
    }

    return getToken(messaging, {
      vapidKey: firebaseConfig.vapidKey,
      serviceWorkerRegistration: registration,
    }).catch((err) => {
      // https://github.com/firebase/firebase-js-sdk/issues/7693
      const error = 'Failed to execute \'subscribe\' on \'PushManager\': Subscription failed - no active Service Worker'
      if (err.toString().indexOf(error) > -1) {
        return getToken(messaging, { vapidKey: firebaseConfig.vapidKey })
      }
      else {
        throw err
      }
    }).then((currentToken) => {
      if (currentToken) {
        return registerFCMToken(currentToken)
      }
      else {
        logger.error('No registration token available. Request permission to generate one.')
        return null
      }
    }).catch((err) => {
      logger.error('Something went wrong when trying to getToken from firebase.', undefined, err)
    })
  }
  const config = useRuntimeConfig()
  const logger = useCanxLogger()
  const firebaseConfig = {
    apiKey: String(config.public.FB_API_KEY),
    authDomain: String(config.public.FB_AUTH_DOMAIN),
    projectId: String(config.public.FB_PROJECT_ID),
    storageBucket: String(config.public.FB_STORAGE_BUCKET),
    messagingSenderId: String(config.public.FB_MESSAGING_SENDER_ID),
    appId: String(config.public.FB_APP_ID),
    measurementId: String(config.public.FB_MEASUREMENT_ID),
    vapidKey: String(config.public.FB_VAPID_KEY as string | undefined),
  }

  const registerFCMToken = (token: string) => {
    return $apiFetch<boolean>(`register_token_${token}`, `/api/notifications/fcm`, { method: 'PUT', body: { token } })
  }

  const unregister = async () => {
    const app = getApp()
    await deleteToken(getMessaging(app))
    // await deleteInstallations(getInstallations(app))
  }

  return {
    getFBToken,
    unregister,
  }
}
